import styled from 'styled-components';
import { respond } from '../../../theme/mixins';

export const PromptWrapper = styled.div`
  padding: 0;
  border-radius: 22px;
  background: var(--ion-color-light);
  background: #fafcff;
  box-shadow: 1px 1px 25px 3px #0009;
  font-size: var(--font-size);
  position: absolute;
  color: #444;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: -moz-fit-content;
  width: fit-content;
  padding: 0;
  top: 60px;
  box-sizing: border-box;
  height: auto;
  transition: transform 0.3s ease-in-out, opacity 0.4s, visibility 0s;
  opacity: 0;
  overflow: visible;
  max-width: 80%;
  pointer-events: none;
  z-index: 20;
  visibility: hidden;
  font-family: var(--font-family-alt);
  .fade-text-wrapper {
    font-size: 2.2rem;
    text-shadow: 1px 2px 3px #000;
    line-height: 1.3;
    color: #fff;
    font-weight: 800;
    text-align: left;
    transition: opacity 25s;
    transition-delay: 8s;
    /* transform: translateY(30px); */
    max-width: 550px;
    width: 90%;
    background: #0000001f;
    border-radius: 10px;
    padding: 18px;
    letter-spacing: 1px;
    font-family: 'Londrina Solid', serif;
    opacity: 1;

    span {
      display: inline-block;
      opacity: 0;
      transition: opacity 1s, transform 0.3s;
      transform: translateY(80px);
      padding: 0 5px;
    }
    &.show {
      transform: translateY(0);
      opacity: 0;

      span {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }
  .body-text {
    padding: 10px 30px 20px;
    width: 90%;
    max-width: 420px;
    margin: 0 auto;
    line-height: 1.6;
    font-size: 0.8rem;
    text-align: left;
    color: var(--chakra-colors-darkBlue-500);
    font-weight: 500;
    letter-spacing: -0.02em;
    b {
      font-weight: 600;
      color: #2d3135e3;
    }
    &.larger {
      font-size: 1rem;
    }
  }
  &.type-1 {
    transform: scale(0.8) translateY(300px) rotate(10deg);
  }
  &.type-2 {
    transform: scale(0.5) translateY(300px);
    width: 90%;
    max-width: 1060px;
    box-shadow: none;
    font-family: var(--font-family-alt);
    box-shadow: 1px 1px 60px 10px #0000006b;
    ${respond.down('sm')} {
      width: 90%;
    }

    .btn-close-prompt {
      right: 0px;
      margin: 0 auto;
      top: -32px;
      background: var(--chakra-colors-newGreen-500);
      border-radius: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 6px 20px;
      color: #ffffff;
      transition: 0.2s;
      width: fit-content;
      &.answered {
        background: #1bab1bfa;
        &:hover {
          background: #17b917fa;
        }
      }
      ion-icon,
      i {
        height: 26px;
        font-size: 22px;
        margin-right: 5px;
      }
      &:hover {
        background: var(--chakra-colors-newGreen-600);
      }
    }
    .body-text {
      max-width: 90%;
      font-size: 1.05rem;
      line-height: 1.7;
      text-align: center;
      padding: 10px 20px 30px;
      &.larger {
        font-size: 1.1rem;
        line-height: 1.8;
      }
      ${respond.down('sm')} {
        line-height: 1.2;
        &.larger {
          font-size: 1rem;
          line-height: 1.2;
        }
      }
    }
    .responses-wrapper {
      display: flex;
      justify-content: center;
      margin: 10px auto 0;
      width: 100%;
      ion-content {
        --background: none;
      }
      /* height: 130px; */
      .swiper {
        margin: -30px auto 0;
        width: calc(100% - 30px);
        padding: 0 20px;
        .swiper-pagination {
          bottom: 0;
        }
        .swiper-pagination-bullet {
          width: 12px;
          height: 12px;
        }
        .swiper-button-next,
        .swiper-button-prev {
          height: 28px;
          width: 28px;
          top: 55%;
          &:after {
            font-size: 18px;
            display: flex;
            align-items: center;
            height: 100%;
            /* background: var(--ion-color-primary); */
            /* color: #fff; */
            width: 100%;
            justify-content: center;
            border-radius: 50%;
          }
          &.swiper-button-next {
            right: 0;
          }
          &.swiper-button-prev {
            left: 0;
          }
        }
        .swiper-slide {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          /* width: 200px; */
        }
      }

      .response {
        /* display: flex; */
        margin: 0 15px;
        transition: 0.2s;
        padding: 7px 12px;
        border-radius: 8px;
        cursor: pointer;
        pointer-events: auto;
        display: flex;
        justify-content: flex-start;
        width: 170px;
        .response-info {
          margin: 0 5px;
        }

        .username {
          padding: 7px 2px 2px;
          pointer-events: none;
        }
        .details {
          font-size: 0.75rem;
          padding: 0;
          color: #777;
          pointer-events: none;
          text-align: left;
          font-weight: 500;
          i {
            color: #4b92de;
            margin: 4px;
          }
        }
      }
      .avatar-circle {
        display: inline-flex;
        border: 2px solid;
        border-radius: 50%;
        padding: 3px;
        cursor: pointer;
        transition: 0.2s;
        transform: scale(1);
        box-shadow: 1px 1px 8px #a5a5a500;
        pointer-events: none;

        .rs-avatar-circle,
        img {
          width: 55px;
          height: 55px;
        }

        &.color-1 {
          border-color: #6c96ce;
        }
        &.color-2 {
          border-color: #8bcc91;
        }
        &.color-3 {
          border-color: #ea9b38;
        }
        &.color-4 {
          border-color: #6765ae;
        }
      }
    }
    .label-text {
      font-weight: 500;
      letter-spacing: -0.3px;
      color: #8a908d;
      font-size: 0.85rem;
    }
    .join-convo {
      pointer-events: none;
      margin: 0 0 40px;
      position: relative;
      display: flex;
      justify-content: center;

      i {
        transform: rotate(225deg);
        position: absolute;
        top: 27px;
        font-size: 22px;
        color: #65cea8;
      }
    }
  }
  &.type-3 {
    box-shadow: none;
    background: #00000040;
    background: none;
  }
  .btn,
  button {
    outline: 0;
  }
  &.show {
    opacity: 1;
    pointer-events: auto;
    visibility: visible;
    transform: scale(1) translateY(0) rotate(0deg);
    margin-top: 60px;
  }
  .response-select-wrapper {
    position: relative;
    margin-top: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    flex-grow: 1;
  }
  .half-circle {
    max-width: 330px;
    width: 100%;
    height: 110px;
    border-top-left-radius: 80px;
    border-top-right-radius: 80px;
    border: 3px solid #f1f5f9;
    border-bottom: 0;
    box-sizing: border-box;
    position: relative;
    margin: 0 auto;

    .btn-respond {
      position: absolute;
      border-radius: 50%;
      padding: 0;
      width: 51px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 1px 1px 10px #48484859;
      cursor: pointer;
      transition: 0.4s;
      transform: rotate(0deg);
      border: 1px dashed transparent;

      &.has-existing {
        /* border: 1px solid #06c306; */
        box-shadow: none;
        &:hover {
          border: 1px dashed transparent;
        }
      }
      i {
        font-size: 26px;
        color: #ffffff;
      }
      &.type-1 {
        left: 75px;
        bottom: 85px;

        background: rgba(var(--type1-color));
        &.has-existing {
          background: rgba(var(--type1-color), 0.35);
        }
        &:hover {
          background: #1fe85f;
        }
      }
      &.type-2 {
        right: 75px;
        bottom: 85px;

        background: rgba(var(--type2-color));
        &.has-existing {
          background: rgba(var(--type2-color), 0.35);
        }
        &:hover {
          background: #1fc3f7;
        }
      }
      &.type-3 {
        left: -25px;
        bottom: 20px;
        background: rgba(var(--type3-color));
        &.has-existing {
          background: rgba(var(--type3-color), 0.35);
        }

        &:hover {
          background: #d635c0;
        }
      }
      &.type-4 {
        right: -25px;
        bottom: 20px;
        margin: 0 auto;
        bottom: 20px;
        background: rgba(var(--type4-color));
        &.has-existing {
          background: rgba(var(--type4-color), 0.35);
        }

        &:hover {
          background: #589aff;
        }
      }
      &.type-5 {
        right: -25px;
        bottom: 20px;
        background: #e8871d;

        &:hover {
          background: #ff8b0b;
        }
      }
      &:hover {
        box-shadow: 1px 1px 12px #484848d4;
        transform: rotate(360deg);
        .completed-check {
          opacity: 0;
          transition-duration: 0.1s;
        }
      }
    }
  }
  .wave-bottom {
    width: 100%;
    svg {
      height: 30%;
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }

  &.pos-top-left {
    top: 70px;
    bottom: initial;
    right: initial;
    left: 40px;
    &:after {
    }
  }
  &.pos-top-right {
    top: 70px;
    bottom: initial;
    left: initial;
    right: 40px;
  }
  &.pos-bottom-left {
    top: initial;
    bottom: 190px;
    left: 40px;
    right: initial;
  }

  &.pos-bottom-right {
    top: initial;
    bottom: 190px;
    left: initial;
    right: 40px;
  }
  &.pos-center {
    top: 50%;
    transform: translateY(-50%);
    bottom: initial;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
  ${respond.down('sm')} {
    &.pos-bottom-left,
    &.pos-top-left,
    &.pos-top-right,
    &.pos-bottom-right {
      left: 0;
      right: 0;
      margin: 0 auto;
      max-width: calc(100% - 30px);

      &.pos-bottom-left,
      &.pos-bottom-right {
        bottom: 240px;
      }
    }
  }

  .btn-close-prompt {
    position: absolute;
    right: 22px;
    z-index: 2;
    color: var(--chakra-colors-darkBlue-500);
    background: white;
    border-radius: 50%;
    transition: 0.1s;
    top: 29px;
    transform: translateY(-50%);
    &:hover,
    &:focus {
      /* color: rgba(var(--ion-color-light-rgb), 1); */
    }
  }
`;

export const PromptActionBarContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  background: white;
  border-radius: 20px;
  padding: 0 0 0 4px;
  width: auto;
  right: 20px;
  left: initial;
  top: initial;
  bottom: -40px;
  height: 60px;
  box-shadow: 0 -1px 17px 2px #00000010;
  flex-direction: row;
  &:after {
    content: ' ';
    position: absolute;
    top: 0;
    right: -4px;
    bottom: 0;
    width: 0;
    box-shadow: -9px 0 22px 2px #000000bf;
    z-index: 1;
    box-sizing: border-box;
    padding: 0;
    background: #fff;
    border-radius: 6px;
  }
  .btn {
    transition: 0.1s;
    border-radius: 50%;
    cursor: pointer;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    ion-icon,
    i {
      color: var(--chakra-colors-darkBlue-500);
      font-size: 24px;
    }
    &:hover,
    &:focus {
      background: white;
      ion-icon,
      i {
        color: var(--chakra-colors-darkBlue-600);
      }
    }
    &.btn-save-note {
      i {
        font-size: 26px;
        position: relative;
        top: 2px;
      }
    }
  }

  .btn-wrapper {
    margin: 0px 8px;
    display: flex;
    /* flex-direction: column; */
    flex-direction: row;
    align-items: center;
    &.saved {
      .btn i {
        color: #75e875;
      }
    }
    ion-badge {
      background: none;
      margin: 1px 0 0;
      font-size: 0.9rem;
      position: relative;
      left: -8px;
      top: 7px;
    }
  }
  ${respond.down('sm')} {
    bottom: -60px;
    left: 0;
    flex-direction: row;
    top: initial;
    width: 80%;
    border-radius: 0 0 8px 8px;
    border-right: none;
    margin: 0 auto;
    right: 0;
    box-shadow: 1px 4px 8px #0009;
    height: auto;
    &:after {
      width: 100%;
      height: 0;
      box-shadow: 0 7px 22px 2px #000000bf;
      right: 0;
      top: -3px;
    }
    .btn-wrapper {
      flex-direction: row;
      align-items: center;
      margin: 0 8px;
      height: 60px;
    }
  }
`;

export const PromptHeader = styled.div`
  color: var(--ion-color-light);
  font-weight: 500;
  text-align: center;
  left: 0;
  right: 0;
  margin: 0 auto;
  display: block;
  position: relative;
  align-items: center;
  padding: 0;
  border-radius: 8px 8px 0 0;
  font-family: var(--font-family-alt);
  &.type-1 {
    background: var(--ion-color-primary);

    .btn-close-prompt {
      color: rgba(var(--ion-color-light-rgb), 0.6);
      &:hover {
        color: rgba(var(--ion-color-light-rgb), 1);
      }
    }
  }
  &.type-2 {
    background: var(--ion-color-primary);
  }
  &.type-3 {
    height: 0;
    display: none;
  }

  .prompt-title {
    text-transform: uppercase;
    padding: 6px 0;
    border-radius: 20px;
    display: inline-flex;
    align-items: center;
    margin: 16px auto 8px;
    font-weight: 500;
    letter-spacing: 2px;
    i {
      font-size: 28px;
      margin-right: 8px;
    }
    &.type-2 {
      margin: 20px auto 15px;
      padding: 2px 0 0;
      position: relative;
    }
  }
`;

export const PromptBody = styled.div`
  /* padding: 10px; */
  gap: 12px;
  text-align: center;
  min-width: 350px;
  overflow: hidden;
  transition: 0.2s;
  position: relative;
  max-height: 60vh;
  overflow-y: auto;
  min-width: 420px;
  &.type-2 {
    height: 60vh;
    max-height: 500px;
    min-height: 370px;
    display: flex;
    width: 100%;
    flex-direction: column;
  }
  &.type-3 {
    overflow: visible;
  }
  .body-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    ${respond.down('sm')} {
      flex-wrap: wrap;
    }
  }

  &.comments-open {
    min-height: 400px;
    width: 100%;
    max-width: 700px;
    .body-inner {
      opacity: 0;
      pointer-events: none;
    }
  }
  ${respond.down('sm')} {
    .body-text {
      padding: 20px 10px 40px;
    }
  }
`;

export const PromptImage = styled.img`
  height: 120px;
  width: 120px;
  border-radius: 50%;
  margin: 30px 0 10px 20px;
  box-shadow: 0px 0px 11px #00000040;
  align-self: start;
`;

export const PromptContinueButton = styled.div`
  width: calc(100% - 300px);
  position: absolute;
  bottom: -57px;
  left: 50px;
  display: none;
  button.btn-continue {
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
    background: #14bb14;
    color: #fff;
    border-radius: 10px;
    font-weight: 500;
    box-shadow: 1px 1px 10px #00000082;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: linear-gradient(90deg, #119a81, #3ae03a);
    background-size: 100%;
    background-position: left center;
    transition: 0.25s;
    i {
      font-size: 20px;
      margin-right: -30px;
      margin-left: 15px;
    }

    &:hover {
      background-size: 200%;
      background-position: right center;
    }
    span {
      display: none;
      font-size: 0.8rem;
      position: absolute;
      right: 20px;
      color: #ffffffa3;
      font-weight: 400;
    }
  }
`;
